import { Component, input } from '@angular/core';
import { ILpCanvasElementContext } from '@features/lp/lp-canvas/lp-canvas.types';
import { Wk8BookContentsComponent } from '@features/wk8/wk8-book/wk8-book-contents/wk8-book-contents.component';
import { LpWk8BookContentsCanvasComponent } from '@typings/lp/generated';

@Component({
  selector: 'wk8-book-contents-canvas-component',
  imports: [Wk8BookContentsComponent],
  templateUrl: './wk8-book-contents-canvas-component.component.html',
  styleUrl: './wk8-book-contents-canvas-component.component.css',
})
export class Wk8BookContentsCanvasComponentComponent {
  comp = input.required<LpWk8BookContentsCanvasComponent>();
  context = input.required<ILpCanvasElementContext>();
}
